import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/store';
import { Navigate } from 'react-router-dom';
import SetAgentPasswordPage from './SetAgentPasswordPage';

const SetAgentPasswordPageWrapper: React.FC = () => {
  const user = useSelector((state: StoreState) => state.user.loggedInUser);

  // Only allow admin users to access this page
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <SetAgentPasswordPage />;
};

export default SetAgentPasswordPageWrapper;